export const CONNECTION_STATE = '__connection_state__'

export const CONNECTION_STATES = {
  CONNECTED: 'connected',
  CONNECTING: 'connecting',
  DISCONNECTED: 'disconnected',
}

// Real-time notification events on the `/notifications` namespace (Confluence
// "Socket.IO real-time notifications — FE connection guide"). Event names are
// unprefixed and match the payload `type` — the bell./popup./toast. prefixes were
// removed in IC-48328 (17/06/2026).
export const CREDITS_EXHAUSTED = 'credits_exhausted'
export const CREDITS_REQUESTED = 'credits_requested'
export const CREDITS_RESTORED = 'credits_restored'

// PAYG credit-limit events (paid customers). The push carries only a `type`
// (+ reset_date_label on the bells); the FE picks bell copy by billing model.
export const PAYG_PROXIMITY_LIMIT_ALERT = 'payg_proximity_limit_alert'
export const PAYG_PROXIMITY_LIMIT_RESTORE = 'payg_proximity_limit_restore'
export const PAYG_LIMIT_REACHED = 'payg_limit_reached'
export const PAYG_LIMIT_RESTORE = 'payg_limit_restore'
export const PAYG_LIMIT_RESET = 'payg_limit_reset'

export const SIMULATIONS_EXPORT_READY = 'simulations_export_ready'
export const SIMULATIONS_EXPORT_ERROR = 'simulations_export_error'
export const PARTICIPANTS_CSV_READY = 'participants_csv_ready'
export const PARTICIPANTS_CSV_ERROR = 'participants_csv_error'
